"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CActions = _interopRequireDefault(require("01_core/components/materials/CActions"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CSelect = _interopRequireDefault(require("01_core/components/materials/CSelect"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _ListIconButton = _interopRequireDefault(require("01_core/components/materials/ListIconButton"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Consts = require("../../common/consts/Consts");
var _ReportListTable = _interopRequireDefault(require("./ReportListTable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 訓練実施報告登録：課題の抽出
 */
class TaskField extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onDeleteClick", data => {
      const list = this.props.reportEntry.repTaskList.slice();
      list.splice(list.indexOf(data), 1);
      list.forEach((item, index) => {
        list[list.indexOf(item)] = _objectSpread(_objectSpread({}, item), {}, {
          taskNo: index + 1
        });
      });
      this.props.setEntry('repTaskList')(list);
      this.props.setList(list);
    });
    _defineProperty(this, "selectBumon", data => value => {
      const {
        kunrenInfo,
        callAPI
      } = this.props;
      callAPI(_APIs.BCM_KUNREN_REPORT_TASK, {
        targetCd: kunrenInfo.targetCd,
        taskCd: value,
        next: true
      }).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          const list = this.props.reportEntry.repTaskList.slice();
          const idx = list.indexOf(data);
          if (idx >= 0) {
            list[idx] = _objectSpread(_objectSpread({}, data), {}, {
              bumon: value,
              kind: '',
              taio: '',
              schedule: '',
              kindList: response.data,
              taioList: []
            });
          }
          this.props.setEntry('repTaskList')(list);
          this.props.setList(list);
        }
      });
    });
    _defineProperty(this, "selectKind", data => value => {
      const {
        kunrenInfo,
        callAPI
      } = this.props;
      callAPI(_APIs.BCM_KUNREN_REPORT_TASK, {
        targetCd: kunrenInfo.targetCd,
        taskCd: value,
        next: true
      }).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          const list = this.props.reportEntry.repTaskList.slice();
          const idx = list.indexOf(data);
          if (idx >= 0) {
            list[idx] = _objectSpread(_objectSpread({}, data), {}, {
              kind: value,
              taio: '',
              taioList: response.data
            });
          }
          this.props.setEntry('repTaskList')(list);
          this.props.setList(list);
        }
      });
    });
    _defineProperty(this, "changeTask", (data, key) => value => {
      const list = this.props.reportEntry.repTaskList.slice();
      const idx = list.indexOf(data);
      if (idx >= 0) {
        list[idx] = _objectSpread(_objectSpread({}, data), {}, {
          [key]: value
        });
      }
      this.props.setEntry('repTaskList')(list);
      this.props.setList(list);
    });
    _defineProperty(this, "onAddClick", () => {
      const {
        kunrenInfo,
        callAPI
      } = this.props;
      callAPI(_APIs.BCM_KUNREN_REPORT_TASK, {
        targetCd: kunrenInfo.targetCd,
        taskCd: _Consts.CONSTS.TASK_JITAISAKUHONBU,
        next: false
      }).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          const list = this.props.reportEntry.repTaskList.slice();
          list.push({
            taskNo: list.length + 1,
            taskCd: '',
            schedule: '',
            task: '',
            taskTree: '',
            bumon: '',
            kind: '',
            taio: '',
            bumonList: response.data,
            kindList: [],
            taioList: []
          });
          this.props.setEntry('repTaskList')(list);
          this.props.setList(list);
        }
      });
    });
  }
  render() {
    const {
      intl,
      reportEntry,
      errors
    } = this.props;
    const columns = [{
      dataKey: 'deleteIcon',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_DELETE
      }),
      width: 60,
      minWidth: 60,
      maxWidth: 60
    }, {
      dataKey: 'bumon',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TASK_BUMON
      }),
      width: 300,
      minWidth: 50
    }, {
      dataKey: 'kind',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TASK_KIND
      }),
      width: 300,
      minWidth: 50
    }, {
      dataKey: 'taio',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TASK_TAIO
      }),
      width: 300,
      minWidth: 50
    }, {
      dataKey: 'schedule',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TASK_SCHEDULE
      }),
      width: 340,
      minWidth: 50
    }, {
      dataKey: 'task',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TASK
      }),
      width: 900
    }];
    const createRow = (data, rowIndex) => {
      var _rowErrors$bumon, _rowErrors$kind, _rowErrors$taio, _rowErrors$schedule, _rowErrors$task;
      const rowErrors = Array.isArray(errors === null || errors === void 0 ? void 0 : errors.repTaskList) ? errors.repTaskList[rowIndex] : undefined;
      const deleteIcon = reportEntry.repTaskList.length === 1 ? null : /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
        action: "delete",
        onClick: () => {
          this.onDeleteClick(data);
        }
      });
      const bumon = !(data.bumonList.length === 0) && /*#__PURE__*/_react.default.createElement(_CSelect.default, {
        value: data.bumon,
        onChange: this.selectBumon(data),
        items: data.bumonList.map(d => ({
          displayName: d.name,
          value: String(d.value)
        })),
        style: {
          maxWidth: 280
        },
        error: !!(rowErrors !== null && rowErrors !== void 0 && rowErrors.bumon),
        helperText: rowErrors === null || rowErrors === void 0 || (_rowErrors$bumon = rowErrors.bumon) === null || _rowErrors$bumon === void 0 ? void 0 : _rowErrors$bumon.message
      });
      const kind = data.bumon && !(data.kindList.length === 0) && /*#__PURE__*/_react.default.createElement(_CSelect.default, {
        value: data.kind === null ? '' : data.kind,
        onChange: this.selectKind(data),
        items: data.kindList.map(d => ({
          displayName: d.name,
          value: String(d.value)
        })),
        style: {
          maxWidth: 280
        },
        error: !!(rowErrors !== null && rowErrors !== void 0 && rowErrors.kind),
        helperText: rowErrors === null || rowErrors === void 0 || (_rowErrors$kind = rowErrors.kind) === null || _rowErrors$kind === void 0 ? void 0 : _rowErrors$kind.message
      });
      const taio = data.kind && !(data.taioList.length === 0) && /*#__PURE__*/_react.default.createElement(_CSelect.default, {
        value: data.taio,
        onChange: this.changeTask(data, 'taio'),
        items: data.taioList.map(d => ({
          displayName: d.name,
          value: String(d.value)
        })),
        style: {
          maxWidth: 280
        },
        error: !!(rowErrors !== null && rowErrors !== void 0 && rowErrors.taio),
        helperText: rowErrors === null || rowErrors === void 0 || (_rowErrors$taio = rowErrors.taio) === null || _rowErrors$taio === void 0 ? void 0 : _rowErrors$taio.message
      });
      const schedule = data.bumon && data.bumon === _Consts.CONSTS.TASK_JITAISAKUHONBU ? /*#__PURE__*/_react.default.createElement(_CTextField.default, {
        value: data.schedule,
        onChange: this.changeTask(data, 'schedule'),
        maxLength: 10,
        error: !!(rowErrors !== null && rowErrors !== void 0 && rowErrors.schedule),
        helperText: rowErrors === null || rowErrors === void 0 || (_rowErrors$schedule = rowErrors.schedule) === null || _rowErrors$schedule === void 0 ? void 0 : _rowErrors$schedule.message
      }) : null;
      const task = /*#__PURE__*/_react.default.createElement(_CTextField.default, {
        value: data.task,
        onChange: this.changeTask(data, 'task'),
        maxLength: 1000,
        multiline: true,
        rows: 2,
        error: !!(rowErrors !== null && rowErrors !== void 0 && rowErrors.task),
        helperText: rowErrors === null || rowErrors === void 0 || (_rowErrors$task = rowErrors.task) === null || _rowErrors$task === void 0 ? void 0 : _rowErrors$task.message
      });
      return {
        deleteIcon,
        bumon,
        kind,
        taio,
        schedule,
        task
      };
    };
    const pushButton = /*#__PURE__*/_react.default.createElement(_CButton.default, {
      autoWidth: true,
      onClick: this.onAddClick
    }, intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_TASK_ADD
    }));
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ReportListTable.default, {
      rowData: reportEntry.repTaskList,
      columns,
      createRow,
      listType: 'TASK'
    }), /*#__PURE__*/_react.default.createElement(_CActions.default, {
      actions: [pushButton]
    }));
  }
}
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(TaskField));